const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
const win = window;
const doc = document;

export default {
    beforeMount() {
        window.addEventListener('resize', this.$_resizeHandler)
        win.addEventListener(resizeEvt, this.reCalcRem, false);
        doc.addEventListener('DOMContentLoaded', this.reCalcRem, false);
    },
    beforeDestroy() {
        win.addEventListener(resizeEvt, this.reCalcRem, false);
        doc.addEventListener('DOMContentLoaded', this.reCalcRem, false);
    },
    mounted() {
        this.reCalcRem();
    },
    methods: {
        reCalcRem() {
            let clientW = doc.documentElement.clientWidth;

            if (!clientW) {
                return;
            }

            clientW = clientW < 320 ? 320 : clientW;

            if (clientW >= 750) {
                doc.getElementsByTagName('html')[0].style.fontSize = '16px';
            } else {
                doc.getElementsByTagName('html')[0].style.fontSize = 16 * (clientW / 750) + 'px';
            }
        }
    }
};